import { render, staticRenderFns } from "./TabellaScarti.vue?vue&type=template&id=3f5894a6&scoped=true&"
import script from "./TabellaScarti.vue?vue&type=script&lang=js&"
export * from "./TabellaScarti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5894a6",
  null
  
)

export default component.exports